// Need to use the React-specific entry point to import createApi
import type {
  FileResponse,
  GetListResponseOfSafetyEventSimpleResponse,
  GetSafetyEventListRequestV2,
  SafetyEventRequest,
  SafetyEventResponse,
} from 'src/api/ProactApiClient';
import {safetyEventApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const safetyEventApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getSafetyEventListV2: builder.query<
      GetListResponseOfSafetyEventSimpleResponse,
      GetSafetyEventListRequestV2
    >({
      queryFn: clientQuery(params => safetyEventApiClient.listV2(params)),
      providesTags: ['SafetyEvents'],
    }),

    getSafetyEvent: builder.query<SafetyEventResponse, number>({
      queryFn: clientQuery(id => safetyEventApiClient.get(id)),
      providesTags: ['SafetyEvents'],
    }),

    createSafetyEvent: builder.mutation<
      SafetyEventResponse,
      SafetyEventRequest
    >({
      queryFn: clientQuery(request => safetyEventApiClient.create(request)),
      invalidatesTags: ['SafetyEvents', 'TaskAssignments'],
    }),

    updateSafetyEvent: builder.mutation<
      SafetyEventResponse,
      SafetyEventRequest
    >({
      queryFn: clientQuery(request => safetyEventApiClient.update(request)),
      invalidatesTags: ['SafetyEvents', 'TaskAssignments'],
    }),

    deleteSafetyEvent: builder.mutation<boolean, number>({
      queryFn: clientQuery(id => safetyEventApiClient.delete(id)),
      invalidatesTags: ['SafetyEvents', 'TaskAssignments'],
    }),

    exportSafetyEvents: builder.mutation<
      FileResponse | null,
      GetSafetyEventListRequestV2
    >({
      queryFn: clientQuery(request => safetyEventApiClient.export(request)),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSafetyEventListV2Query,
  useGetSafetyEventQuery,
  useCreateSafetyEventMutation,
  useUpdateSafetyEventMutation,
  useDeleteSafetyEventMutation,
  useExportSafetyEventsMutation,
} = safetyEventApi;
